// extracted by mini-css-extract-plugin
export default {"error":"styles_error__EABK1","products":"styles_products__+bDaB","name":"styles_name__8sNyY"};